import {ReactElement, CSSProperties, Children} from "react";
import Paper from "material-ui/Paper";

import {
  prepareStyles, mergeStyles, cloneElementWithStyle,
} from "src/utils/components";
import Drawer from "src/components/Drawer";


const styles = prepareStyles({
  root: {
    display: 'flex',
  },

  drawer: {
    flex: '0 0 auto',
    zIndex: 100,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },

  sidebar: {
    flex: '1 1 0',
  },

  paper: {
    flex: '1 1 0',
    zIndex: 200,
    display: 'flex',
  },

  content: {
    flex: '1 1 0',
    overflow: 'hidden',
  },
});


export interface LayoutWithSidebarProps {
  children?: ReactElement<{style: CSSProperties}>;
  sidebarElement: ReactElement<any>;
  style?: CSSProperties;
}


/**
 * Layout with fixed-width sidebar on the left and elevated flexible content on
 * the right.
 *
 * Only single child may be passed which will be rendered full-height.
 */
const LayoutWithSidebar = (props: LayoutWithSidebarProps) => {
  const sidebar = cloneElementWithStyle(props.sidebarElement, styles.sidebar);

  const content = Children.count(props.children) === 0 ? null :
    cloneElementWithStyle(Children.only(props.children), styles.content);

  return <div style={mergeStyles(styles.root, props.style)}>
    <Drawer style={styles.drawer}>{sidebar}</Drawer>

    <Paper style={styles.paper} zDepth={1} rounded={false}>
      {content}
    </Paper>
  </div>;
};

export default LayoutWithSidebar;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/LayoutWithSidebar.tsx